'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var rmAll = require('./rm-all');

var last = require('it-last');

var configure = require('../lib/configure');

module.exports = function (options) {
  var all = rmAll(options);
  return configure(function () {
    return (
      /*#__PURE__*/
      function () {
        var _rm = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(path) {
          var options,
              _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                  return _context.abrupt("return", last(all(_objectSpread({
                    path: path
                  }, options), options)));

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function rm(_x) {
          return _rm.apply(this, arguments);
        }

        return rm;
      }()
    );
  })(options);
};